import {
  activeSiteTabPanelCameraCardSelector,
  cameraSelectorActiveSiteTabSelector,
  cameraSelectorSiteTabSelector,
} from '../cameraSelector.constants.ts';

const isVisibleElement = (element: HTMLElement) => {
  const { width, height } = element.getBoundingClientRect();
  return width > 0 && height > 0;
};
export const focusCameraSelectCard = (target: HTMLElement) => {
  target.focus({ preventScroll: true });
  target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
};
export const focusActiveSiteTab = () => {
  const target = document.querySelector<HTMLElement>(cameraSelectorActiveSiteTabSelector);
  if (!target) return;
  focusCameraSelectCard(target);
};
export const getCameraSelectorSiteTabs = () =>
  Array.from(document.querySelectorAll<HTMLElement>(cameraSelectorSiteTabSelector)).filter(
    isVisibleElement
  );
export const getVisibleActiveSiteCameraCards = () =>
  Array.from(
    document.querySelectorAll<HTMLButtonElement>(activeSiteTabPanelCameraCardSelector)
  ).filter(isVisibleElement);
